// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import it from './it'

const locales = {
  en: en,
  fr: fr,
  it: it
}

export default locales
